import { render, staticRenderFns } from "./familyResidence.vue?vue&type=template&id=a6ca1d22"
import script from "./familyResidence.vue?vue&type=script&lang=js"
export * from "./familyResidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports